<button mat-stroked-button
        [disabled]="disabled"
        (click)="edit()">
  <mat-icon>settings</mat-icon>
</button>
